import { defineAction } from '~/prix'
import alertFetchAction from './alertFetch.action.json' with { type: 'json' }
import { alertObject } from '../alertObject'
import { z } from 'zod'
import { communityObject } from '~/packages/geo/community/communityObject'

const alertFetchDefinition = defineAction({
  ...alertFetchAction,

  input: z.object({
    id: z.string().uuid(),
  }),
  output: alertObject.extend({
    community: communityObject.nullish(),
  }),
})

export default alertFetchDefinition
